import { useState, useEffect } from "react";
import { API } from "../../App";
import { toast } from "sonner";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Laptop, Smartphone, Tablet, Monitor, Printer } from "lucide-react";

const categoryIcons = {
  smartphone: Smartphone,
  tablette: Tablet,
  ordinateur_portable: Laptop,
  ordinateur_fixe: Monitor,
  imprimante: Printer,
  ecran: Monitor,
};

const categoryLabels = {
  smartphone: "Smartphone",
  tablette: "Tablette",
  ordinateur_portable: "PC Portable",
  ordinateur_fixe: "PC Fixe",
  imprimante: "Imprimante",
  ecran: "Écran",
  autre: "Autre",
};

const ClientPortalDevices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const res = await API.get("/portal/devices");
        setDevices(res.data);
      } catch (error) {
        toast.error("Erreur lors du chargement");
      } finally {
        setLoading(false);
      }
    };
    fetchDevices();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="client-portal-devices">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Mes appareils</h1>
        <p className="text-muted-foreground">Liste de tous vos appareils enregistrés</p>
      </div>

      {devices.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2">
          {devices.map((device) => {
            const Icon = categoryIcons[device.categorie] || Laptop;
            return (
              <Card key={device.id} data-testid={`device-card-${device.id}`}>
                <CardContent className="p-5">
                  <div className="flex items-start gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 flex-shrink-0">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="font-semibold">{device.marque} {device.modele}</p>
                        <Badge variant="secondary" className="text-xs">
                          {categoryLabels[device.categorie] || device.categorie}
                        </Badge>
                      </div>
                      {device.numero_serie && (
                        <p className="text-sm text-muted-foreground">N/S: {device.numero_serie}</p>
                      )}
                      {device.imei && (
                        <p className="text-sm text-muted-foreground">IMEI: {device.imei}</p>
                      )}
                      {device.couleur && (
                        <p className="text-sm text-muted-foreground">Couleur: {device.couleur}</p>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      ) : (
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-16 text-center">
            <Laptop className="h-12 w-12 text-muted-foreground mb-4" />
            <p className="font-medium">Aucun appareil</p>
            <p className="text-sm text-muted-foreground">Vos appareils déposés apparaîtront ici</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default ClientPortalDevices;
